var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBinoculars = function SvgBinoculars(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 123.625,
    y1: 26.64925,
    x2: 123.625,
    y2: 37.42075,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 48.375,
    y1: 26.64925,
    x2: 48.375,
    y2: 37.42075,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 68.980057,
    x2: 86,
    y2: 80.633057,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 23.292561,
    x2: 86,
    y2: 149.642685,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8869698"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 33.59375 8.59375 L 38.28125 8.59375 L 38.28125 10.15625 L 33.59375 10.15625 Z M 33.59375 8.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 11.71875 8.59375 L 16.40625 8.59375 L 16.40625 10.15625 L 11.71875 10.15625 Z M 11.71875 8.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 30.46875 21.875 C 30.46875 22.304688 30.117188 22.65625 29.6875 22.65625 L 20.3125 22.65625 C 19.882812 22.65625 19.53125 22.304688 19.53125 21.875 C 19.53125 21.445312 19.882812 21.09375 20.3125 21.09375 L 29.6875 21.09375 C 30.117188 21.09375 30.46875 21.445312 30.46875 21.875 Z M 30.46875 21.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 43.707031 32.160156 L 42.289062 12.328125 C 42.203125 11.109375 41.171875 10.15625 39.953125 10.15625 L 39.84375 10.15625 L 39.84375 9.375 C 39.84375 8.082031 38.792969 7.03125 37.5 7.03125 L 34.375 7.03125 C 33.082031 7.03125 32.03125 8.082031 32.03125 9.375 L 32.03125 10.15625 L 31.921875 10.15625 C 30.703125 10.15625 29.671875 11.109375 29.585938 12.335938 L 29.179688 17.96875 L 20.820312 17.96875 L 20.414062 12.328125 C 20.328125 11.109375 19.296875 10.15625 18.078125 10.15625 L 17.96875 10.15625 L 17.96875 9.375 C 17.96875 8.082031 16.917969 7.03125 15.625 7.03125 L 12.5 7.03125 C 11.207031 7.03125 10.15625 8.082031 10.15625 9.375 L 10.15625 10.15625 L 10.046875 10.15625 C 8.828125 10.15625 7.796875 11.109375 7.710938 12.335938 L 6.292969 32.160156 C 5.363281 32.472656 4.6875 33.34375 4.6875 34.375 L 4.6875 40.625 C 4.6875 41.917969 5.738281 42.96875 7.03125 42.96875 L 21.09375 42.96875 C 22.386719 42.96875 23.4375 41.917969 23.4375 40.625 L 23.4375 34.375 C 23.4375 33.34375 22.761719 32.472656 21.832031 32.160156 L 21.375 25.78125 L 28.625 25.78125 L 28.167969 32.160156 C 27.238281 32.472656 26.5625 33.34375 26.5625 34.375 L 26.5625 40.625 C 26.5625 41.917969 27.613281 42.96875 28.90625 42.96875 L 42.96875 42.96875 C 44.261719 42.96875 45.3125 41.917969 45.3125 40.625 L 45.3125 34.375 C 45.3125 33.34375 44.636719 32.472656 43.707031 32.160156 Z M 33.59375 9.375 C 33.59375 8.945312 33.945312 8.59375 34.375 8.59375 L 37.5 8.59375 C 37.929688 8.59375 38.28125 8.945312 38.28125 9.375 L 38.28125 10.15625 L 33.59375 10.15625 Z M 31.921875 11.71875 L 39.953125 11.71875 C 40.359375 11.71875 40.703125 12.039062 40.734375 12.445312 L 40.792969 13.28125 L 31.082031 13.28125 L 31.140625 12.445312 C 31.171875 12.039062 31.515625 11.71875 31.921875 11.71875 Z M 31.25 19.53125 C 31.679688 19.53125 32.03125 19.882812 32.03125 20.3125 L 32.03125 23.4375 C 32.03125 23.867188 31.679688 24.21875 31.25 24.21875 L 18.75 24.21875 C 18.320312 24.21875 17.96875 23.867188 17.96875 23.4375 L 17.96875 20.3125 C 17.96875 19.882812 18.320312 19.53125 18.75 19.53125 Z M 11.71875 9.375 C 11.71875 8.945312 12.070312 8.59375 12.5 8.59375 L 15.625 8.59375 C 16.054688 8.59375 16.40625 8.945312 16.40625 9.375 L 16.40625 10.15625 L 11.71875 10.15625 Z M 10.046875 11.71875 L 18.078125 11.71875 C 18.484375 11.71875 18.828125 12.039062 18.859375 12.445312 L 18.917969 13.28125 L 9.207031 13.28125 L 9.265625 12.445312 C 9.296875 12.039062 9.640625 11.71875 10.046875 11.71875 Z M 21.875 40.625 C 21.875 41.054688 21.523438 41.40625 21.09375 41.40625 L 7.03125 41.40625 C 6.601562 41.40625 6.25 41.054688 6.25 40.625 L 6.25 39.84375 L 14.0625 39.84375 L 14.0625 38.28125 L 6.25 38.28125 L 6.25 36.71875 L 10.9375 36.71875 L 10.9375 35.15625 L 6.25 35.15625 L 6.25 34.375 C 6.25 33.945312 6.601562 33.59375 7.03125 33.59375 L 21.09375 33.59375 C 21.523438 33.59375 21.875 33.945312 21.875 34.375 Z M 20.253906 32.03125 L 7.871094 32.03125 L 9.09375 14.84375 L 19.027344 14.84375 L 19.25 17.96875 L 18.75 17.96875 C 17.457031 17.96875 16.40625 19.019531 16.40625 20.3125 L 16.40625 23.4375 C 16.40625 24.730469 17.457031 25.78125 18.75 25.78125 L 19.804688 25.78125 Z M 31.25 25.78125 C 32.542969 25.78125 33.59375 24.730469 33.59375 23.4375 L 33.59375 20.3125 C 33.59375 19.019531 32.542969 17.96875 31.25 17.96875 L 30.75 17.96875 L 30.972656 14.84375 L 40.90625 14.84375 L 42.128906 32.03125 L 29.746094 32.03125 L 30.195312 25.78125 Z M 42.96875 41.40625 L 28.90625 41.40625 C 28.476562 41.40625 28.125 41.054688 28.125 40.625 L 28.125 34.375 C 28.125 33.945312 28.476562 33.59375 28.90625 33.59375 L 42.96875 33.59375 C 43.398438 33.59375 43.75 33.945312 43.75 34.375 L 43.75 35.15625 L 39.0625 35.15625 L 39.0625 36.71875 L 43.75 36.71875 L 43.75 38.28125 L 35.9375 38.28125 L 35.9375 39.84375 L 43.75 39.84375 L 43.75 40.625 C 43.75 41.054688 43.398438 41.40625 42.96875 41.40625 Z M 42.96875 41.40625 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBinoculars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/binoculars.66ca94e6.svg";
export { ForwardRef as ReactComponent };